import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
	Row,
	Col,
	Skeleton,
	Card,
	Tooltip,
	Space,
	DatePicker,
	Button,
	List,
	Avatar,
	Progress,
	Flex,
	Tag,
	Dropdown,
	Badge,
	Radio,
	Segmented,
	Divider,
	Grid,
	Spin,
} from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import DashboardJson from '../../json/Reclaim.json';
import LoaderJson from '../../json/loader.json';
import HeaderFile from '../../components/Header/HeaderFile';
// import { XThemeContainer } from '../../styles/GlobalThemeStyle';
import {
	XThemeContainer,
	XTheme2MainTitle,
	XTheme2Button,
	XTheme2AITag,
	XTheme2VATag,
	XTheme2Form,
} from '../../styles/GlobalThemeStyleCQ';
import AIInput from '../../components/ui/ai-input';
import { Counter } from '../../components/ui/counter';
import {
	XThemeButton,
	XThemeCardFancy,
	XThemeGradientFilterBtn,
	XThemeRadio,
	XThemeSelect,
	XThemeMobileDashboard,
	XThemeDrawer,
	XThemeFilterButton,
	XThemeFilterCircleButton,
	XThemeForm,
	XThemeMobileTableCard,
	XThemeMobileScrollCard,
} from '../../styles/GlobalThemeStyle';
import {
	XThemeReactSpeedometer,
	XThemeModalAnimation,
	XThemeCardTitle1,
	XThemeCardTitle2,
	XThemeCaseCard,
	XThemeCardTitle3,
	XThemeStatisticsCard,
	XThemeStatisticsGraphCard,
	XThemeReimbursementCard,
	XThemePayersCard,
	XThemeSwitch,
	XThemeTableCharts,
	XThemeLottie,
	XThemeLottieLoader,
	XThemeCreateCaseBtn,
} from './ReclaimDashboardStyle';
import CaseManagement from '../Manage/CaseManagement';

import {
	checkModulePermissions,
	getDate,
	getUserName,
} from '../../utils/helper';
import moment from 'moment';
import CaseAnalysis from '../CaseAnalysis/CaseAnalysis';
import DonutChart from '../../components/Chart/DashboardChart';
import {
	getCaseChartDetailsApi,
	getCaseChartDetailsReset,
} from '../../actions/getCaseChartDetailsAction';
import {
	getTotalCaseAmountApi,
	getTotalCaseAmountReset,
} from '../../actions/getTotalCaseAmountAction';
import Header from '../../components/Header/Header';

import CaseClosure from '../CaseClosure/CaseClosure';
import FeedBackList from '../FeedBackAnalysis/FeedBackList';
import AppealLetter from '../AppealLetter/AppealLetter';

import {
	CaretDownOutlined,
	DownloadOutlined,
	DownOutlined,
	EditOutlined,
	InfoCircleOutlined,
	MoreOutlined,
	PlusOutlined,
	TwitterOutlined,
	UserOutlined,
} from '@ant-design/icons';
import {
	getInsuranceCompaniesStatisticsApi,
	getInsuranceCompaniesStatisticsReset,
} from '../../actions/getInsuranceCompaniesStatisticsAction';
import {
	getInsuranceCompaniesFilingStatusCountsApi,
	getInsuranceCompaniesFilingStatusCountsReset,
} from '../../actions/getInsuranceCompaniesFilingStatusCountsAction';
import {
	getInsuranceCompaniesBucketApi,
	getInsuranceCompaniesBucketReset,
} from '../../actions/getInsuranceCompaniesBucketAction';
import { XRadio, XRadioHeader } from '../CaseForm/CaseFormStyle';
import {
	getInsuranceDropdownApi,
	getInsuranceDropdownReset,
} from '../../actions/getInsuranceDropdownAction';
import {
	getCaseAmountBucketApi,
	getCaseAmountBucketReset,
} from '../../actions/getCaseAmountBucketAction';
import {
	getPreCalculatedDataApi,
	getPreCalculatedDataReset,
} from '../../actions/getPreCalculatedDataAction';
import { filterByLabel } from '../../utils/formFunctions';
import config from '../../config';
import HalfDonutChart from '../../components/Chart/DashboardHalfDonutChart';
import {
	XTheme2AvatarListCard,
	XTheme2Badge,
	XTheme2Card,
	XTheme2ChatBox,
	XTheme2CustomSelect,
	XTheme2DropdownStatus,
	XTheme2Graph,
	XTheme2GraphExtra,
	XTheme2InnerCard,
	XTheme2InsurancePayerCard,
	XTheme2InsuranceSpace,
	XTheme2ListBtn,
	XTheme2ListCard,
	XTheme2ListNumber,
	XTheme2Para1,
	XTheme2Progress,
	XTheme2Radio,
	XTheme2ReclaimCard,
	XTheme2Refresh,
	XTheme2ScoreGraph,
	XTheme2Segmented,
	XTheme2TextButton,
	XTheme2Title2,
	XTheme2ViewMoreListCard,
	XTheme2ViewMorePending,
	XTheme2ViewMoreTitle,
	XThemeDashboardLottieCard,
} from './ReclaimDashboardStyleCQ';
import { getCountByFilingAndRevenueApi } from '../../actions/getCountByFilingAndRevenueAction';
import {
	HeaderTitle,
	XThemeDateDays,
} from '../../components/Header/HeaderStyle';
import DashboardLoaderJson from '../../json/dashboard_loader.json';
import { XLottieLetter } from '../AnalyseCoverage/AnalyseCoverageStyle';
import { XVSLottie } from '../VoiceAssistance/VoiceAssistanceStyle';

import ReclaimDashboardChart from '../../components/Chart/ReclaimDashboardChart';
import ReclaimDashboardScoreChart from '../../components/Chart/ReclaimDashboardScoreChart';
import {
	getNanoCarrierDetailsApi,
	getNanoCarrierDetailsReset,
} from '../../actions/getNanoCarrierDetailsAction';
import axios from 'axios'; // Add this at the top if not already imported
import { getUserToken } from '../../utils/helper'; // Add this if not already imported
import ReclaimInput from '../../components/ui/ai-input/reclaim';

// Simple hook to detect if user just logged in
const useLoginDetection = () => {
	const [isLogin, setIsLogin] = useState(false);

	useEffect(() => {
		const loginTimestamp = localStorage.getItem('loginTimestamp');
		const currentTime = Date.now();
		const isRecentLogin =
			loginTimestamp && currentTime - parseInt(loginTimestamp) < 30000; // 30 seconds

		if (isRecentLogin) {
			setIsLogin(true);
			localStorage.removeItem('loginTimestamp'); // Clear after use
		} else {
			setIsLogin(false);
		}
	}, []);

	return { isLogin };
};

const ReclaimDashboard = (props) => {
	const {
		getCarrierScoreCard,
		getCarrierScoreCardState,
		getCarrierScoreCardReset,
	} = props;
	// Initialize your default state values
	const navigate = useNavigate();
	const [expandedCards, setExpandedCards] = useState({});
	const [loading, setLoading] = useState(true);
	const [carrierData, setCarrierData] = useState([]);

	// Use the simplified login detection hook
	const { isLogin } = useLoginDetection();

	// Simple duration logic
	const getLoaderDuration = () => {
		return isLogin ? 10000 : 2000; // 10s for login, 2s for others
	};

	const getGreeting = () => {
		const currentHour = moment().hour();

		if (currentHour >= 5 && currentHour < 12) {
			return 'Good Morning,';
		} else if (currentHour >= 12 && currentHour < 17) {
			return 'Good Afternoon,';
		} else {
			return 'Good Evening,';
		}
	};

	const formatNumber = (cost) => {
		if (cost === 0) {
			return '0';
		}
		const costFloat = parseFloat(cost);
		const suffixes = ['K', 'M', 'B', 'T'];

		let formattedCost = costFloat;

		let suffix = '';
		for (const s of suffixes) {
			if (formattedCost < 1000) {
				break;
			}
			formattedCost /= 1000.0;
			suffix = s;
		}

		// Use parseFloat to remove trailing zeros after decimal
		// return `${parseFloat(formattedCost.toFixed(2))}${suffix}`;
		return `${Math.round(formattedCost)}${suffix}`;
		//Old
		// return `${formattedCost.toFixed(2)}${suffix}`;
	};

	// useEffect(() => {
	// 	getCarrierScoreCard();
	// }, []);

	// useEffect(() => {
	// 	if (getCarrierScoreCardState?.apiState === 'loading') {
	// 	}
	// 	if (getCarrierScoreCardState?.apiState === 'success') {
	// 		console.log(getCarrierScoreCardState.data)
	// 		setCarrierData(getCarrierScoreCardState.data);
	// 	}
	// 	if (getCarrierScoreCardState?.apiState === 'error') {
	// 		setLoading(false);
	// 	}
	// 	getCarrierScoreCardReset();
	// }, []);

	useEffect(() => {
		const fetchCarrierData = async () => {
			try {
				const response = await axios.get(
					`${config.api.base_url}/dashboard/get-nano-carrier-details`,
					{
						headers: {
							Authorization: 'Bearer ' + getUserToken(),
						},
					},
				);
				// Adjust this depending on the actual response structure
				setCarrierData(response.data.data || []);
			} catch (error) {
				console.error('Failed to fetch carrier data:', error);
				setCarrierData([]); // Optionally clear on error
			}
		};

		fetchCarrierData();
	}, []);

	const handleDownloadSample = () => {
		const link = document.createElement('a');
		link.href = '/Final Nano Carrier details with reason code.xlsx'; // Assuming the file is in the public/samples folder
		link.download = 'Nano Health Denial Data.xlsx';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	// Add this function to handle card expansion
	const handleCardExpand = (companyId) => {
		setExpandedCards((prev) => {
			const newState = {
				...prev,
				[companyId]: !prev[companyId],
			};
			return newState;
		});
	};

	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;

	useEffect(() => {
		const duration = getLoaderDuration();
		const timer = setTimeout(() => {
			setLoading(false);
		}, duration);
		return () => clearTimeout(timer);
	}, [isLogin]); // Re-run when login status changes

	return (
		<>
			<>
				<Col lg={24} xl={24} xs={0} md={0}>
					<Header
						subHeader={`${getGreeting()}`}
						headerTag={`${getUserName()}`}
					/>
				</Col>
				<Col lg={0} xl={0} xs={24} md={24}>
					<HeaderFile activeNav="dashboard" />
				</Col>
			</>

			{loading ? (
				// Simple loader decision
				(() => {
					return isLogin ? (
						<XVSLottie
							className="relativePositions"
							animationData={DashboardLoaderJson}
							loop={false}
						/>
					) : (
						<div
							style={{
								position: 'fixed',
								top: 0,
								left: 0,
								width: '100vw',
								height: '100vh',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								backgroundColor: 'rgba(255, 255, 255, 0.8)',
								zIndex: 9999,
							}}
						>
							<Spin size="large" />
						</div>
					);
				})()
			) : (
				<>
					{/* New Dashboard */}
					<XThemeContainer fluid>
						<Row
							gutter={[15, 15]}
							className="align-items-center mb-4"
						>
							<Col
								xs={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-start"
							>
								<XTheme2MainTitle className="mb-2">
									{getGreeting()} <span>{getUserName()}</span>
								</XTheme2MainTitle>
								<XTheme2Para1>
									Track your progress here. You almost reach a
									goal!
								</XTheme2Para1>
							</Col>
							{/* {checkModulePermissions('case-management').authorized ||
					checkModulePermissions('case-closure').authorized ? ( */}
							<Col
								xs={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-end"
							>
								<Space>
									{/* {checkModulePermissions('case-management')
									.authorized && */}
									{isMobile ? (
										<>
											<XTheme2Button
												shape="circle"
												size="large"
												className="noBackground borderColor"
												onClick={() =>
													navigate('/case/add')
												}
												icon={<PlusOutlined />}
											/>
											<XTheme2Button
												shape="circle"
												size="large"
												className="recalim noBackground borderColor"
												onClick={handleDownloadSample}
												icon={<DownloadOutlined />}
											/>
										</>
									) : (
										<>
											<Link to="/case/add">
												<XTheme2Button
													size="large"
													icon={<PlusOutlined />}
												>
													Create New Case
												</XTheme2Button>
											</Link>
											<XTheme2Button
												className="noBackground"
												size="large"
												onClick={handleDownloadSample}
												icon={<DownloadOutlined />}
											>
												Export Report
											</XTheme2Button>
										</>
									)}
									{/* } */}
								</Space>
							</Col>
							{/* ) : (
						<></>
					)} */}
						</Row>
						<Row gutter={[15, 15]} className="mb-3">
							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								<XTheme2InnerCard>
									<Row gutter={[15, 15]}>
										{/* {checkModulePermissions(
									'dashboard',
								).sub_modules.includes('view-case-amount') ? ( */}
										<>
											<Col
												xs={24}
												sm={12}
												md={8}
												lg={8}
												xl={8}
												className="mb-3 mb-sm-0"
											>
												<div className="insideCard borderRight">
													<div className="imgWrapper">
														<img
															className="img-fluid"
															src="images/total-case-new.svg"
															alt=""
														/>
													</div>
													<div className="textWrapper">
														<span className="title">
															Total Denials
														</span>
														<div className="numberWrapper">
															{'2778'}
														</div>
													</div>
												</div>
											</Col>
											<Col
												xs={24}
												sm={12}
												md={8}
												lg={8}
												xl={8}
												className="mb-3 mb-md-0"
											>
												<div className="insideCard borderRight">
													<div className="imgWrapper">
														<img
															className="img-fluid"
															src="images/total-case-value.svg"
															alt=""
														/>
													</div>
													<div className="textWrapper">
														<span className="title">
															Total Denial Value
														</span>
														<div className="numberWrapper">
															{`$ 313,539`}
														</div>
													</div>
												</div>
											</Col>
										</>
										{/* // ) : (
								 	<></>
								 )} */}
										{/* {checkModulePermissions(
									'dashboard',
								).sub_modules.includes('view-reimbursement') ? ( */}
										<Col
											xs={24}
											sm={24}
											md={8}
											lg={8}
											xl={8}
										>
											<div className="insideCard">
												<div className="imgWrapper">
													<img
														className="img-fluid"
														src="images/reimbursement-new.svg"
														alt=""
													/>
												</div>
												<div className="textWrapper">
													<span className="title">
														Total Carrier
													</span>
													<div className="numberWrapper">
														{`47`}
													</div>
												</div>
											</div>
										</Col>
										{/* ) : (
									<></>
								)} */}
									</Row>
								</XTheme2InnerCard>
							</Col>
						</Row>
						{/* //TODO: VA this */}
						<Row gutter={[15, 15]} className="mb-4">
							<Col xs={24} sm={24} md={24} lg={12} xl={12}>
								<XTheme2Card className="gradientCard text-center h-100 d-flex flex-column justify-content-end">
									<XThemeDashboardLottieCard
										animationData={DashboardJson}
										loop={true}
									/>

									<XTheme2MainTitle className="style1 mt-5 mb-2">
										How can I assist you today?
									</XTheme2MainTitle>
									<XTheme2ChatBox className="mt-4">
										<ReclaimInput
											onSubmit={(message) => {
												// Navigate to VoiceAssistance with message in state
												navigate('/agent-maxx', {
													state: {
														dashboardMessage:
															message,
														fromDashboard: true,
													},
												});
											}}
										/>
									</XTheme2ChatBox>
								</XTheme2Card>
							</Col>
							<Col xs={24} sm={24} md={24} lg={12} xl={12}>
								<XTheme2Card
									title="Denials Trend"
									extra={
										<>
											<XTheme2GraphExtra>
												<div className="value">
													<span></span>Total Value
												</div>
												<div className="count">
													<span></span>Total Count
												</div>
											</XTheme2GraphExtra>
										</>
									}
								>
									<ReclaimDashboardChart />
								</XTheme2Card>
							</Col>
						</Row>
						<>
							<Row
								gutter={[15, 15]}
								className="mb-3 align-items-center"
							>
								<Col xs={24} sm={24} md={6} lg={6} xl={6}>
									<XTheme2MainTitle className="style1">
										Top 5 Denial Reasons
									</XTheme2MainTitle>
								</Col>
								<Col
									xs={24}
									sm={24}
									md={18}
									lg={18}
									xl={18}
									className="text-md-end"
								></Col>
							</Row>

							<XTheme2InsurancePayerCard className="mb-2">
								<Row
									gutter={[15, 15]}
									className="align-items-center"
								>
									<Col xs={4} sm={2} md={2} lg={1}>
										<div className="payerLogo">01</div>
									</Col>
									<Col xs={20} sm={20} md={20} lg={20}>
										<div className="payerName">
											Need further information for
											investigation
										</div>
									</Col>
									<Col
										xs={24}
										sm={2}
										md={2}
										lg={3}
										className="text-end"
									>
										<XTheme2ListNumber
											classNames="customButton"
											size="middle"
										>
											927
										</XTheme2ListNumber>
									</Col>
								</Row>
							</XTheme2InsurancePayerCard>

							<XTheme2InsurancePayerCard className="mb-2">
								<Row
									gutter={[15, 15]}
									className="align-items-center"
								>
									<Col xs={4} sm={2} md={2} lg={1}>
										<div className="payerLogo">02</div>
									</Col>
									<Col xs={20} sm={20} md={20} lg={20}>
										<div className="payerName">
											Non-covered charge(s). At least one
											Remark Code must be provided (may be
											comprised of either the NCP...
										</div>
									</Col>
									<Col
										xs={24}
										sm={2}
										md={2}
										lg={3}
										className="text-end"
									>
										<XTheme2ListNumber
											classNames="customButton"
											size="middle"
										>
											37
										</XTheme2ListNumber>
									</Col>
								</Row>
							</XTheme2InsurancePayerCard>

							<XTheme2InsurancePayerCard className="mb-2">
								<Row
									gutter={[15, 15]}
									className="align-items-center"
								>
									<Col xs={4} sm={2} md={2} lg={1}>
										<div className="payerLogo">03</div>
									</Col>
									<Col xs={20} sm={20} md={20} lg={20}>
										<div className="payerName">
											Charge exceeds fee schedule/maximum
											allowable or contracted/legislated
											fee arrangement. (Use only wi...
										</div>
									</Col>
									<Col
										xs={24}
										sm={2}
										md={2}
										lg={3}
										className="text-end"
									>
										<XTheme2ListNumber
											classNames="customButton"
											size="middle"
										>
											31
										</XTheme2ListNumber>
									</Col>
								</Row>
							</XTheme2InsurancePayerCard>

							<XTheme2InsurancePayerCard className="mb-2">
								<Row
									gutter={[15, 15]}
									className="align-items-center"
								>
									<Col xs={4} sm={2} md={2} lg={1}>
										<div className="payerLogo">04</div>
									</Col>
									<Col xs={20} sm={20} md={20} lg={20}>
										<div className="payerName">
											Claim/service lacks information or
											has submission/billing error(s)
											which is needed for adjudication....
										</div>
									</Col>
									<Col
										xs={24}
										sm={2}
										md={2}
										lg={3}
										className="text-end"
									>
										<XTheme2ListNumber
											classNames="customButton"
											size="middle"
										>
											20
										</XTheme2ListNumber>
									</Col>
								</Row>
							</XTheme2InsurancePayerCard>

							<XTheme2InsurancePayerCard className="mb-2">
								<Row
									gutter={[15, 15]}
									className="align-items-center"
								>
									<Col xs={4} sm={2} md={2} lg={1}>
										<div className="payerLogo">05</div>
									</Col>
									<Col xs={20} sm={20} md={20} lg={20}>
										<div className="payerName">
											Sequestration - reduction in federal
											payment
										</div>
									</Col>
									<Col
										xs={24}
										sm={2}
										md={2}
										lg={3}
										className="text-end"
									>
										<XTheme2ListNumber
											classNames="customButton"
											size="middle"
										>
											19
										</XTheme2ListNumber>
									</Col>
								</Row>
							</XTheme2InsurancePayerCard>
						</>
						<>
							<Row gutter={[15, 15]} className="mt-4 mb-3">
								<Col xs={24} sm={24} md={8} lg={8} xl={8}>
									<XTheme2MainTitle className="style1">
										Carriers Score Card
									</XTheme2MainTitle>
								</Col>
								<Col
									xs={24}
									sm={24}
									md={16}
									lg={16}
									xl={16}
									className="text-md-end"
								>
									{/* Added new button */}
									{/* <XTheme2Button
										className="recalim noBackground px-4"
										size="small"
									>
										View All
									</XTheme2Button> */}
								</Col>
							</Row>

							<Row gutter={[15, 15]}>
								{carrierData?.length > 0 ? (
									carrierData.map((company, index) => (
										<Col
											key={index}
											xs={24}
											sm={12}
											md={12}
											lg={6}
											xl={6}
											className="text-center"
										>
											<XTheme2Card
												className="noPadding"
												style={{
													height: 'auto', // Add this
													display: 'flex', // Add this
													flexDirection: 'column', // Add this
												}}
											>
												<div className="payerLogo">
													{company.totalcount}
												</div>
												<div className="payerName my-3">
													{company.carrier}
												</div>
												<XTheme2ScoreGraph>
													<ReclaimDashboardScoreChart
														data={company.details}
													/>
												</XTheme2ScoreGraph>

												<div className="title largeTitle">
													$
													{formatNumber(
														company.totalBalance,
													)}
												</div>
												<div className="title smallTitle">
													Total Value
												</div>

												<div className="w-100 text-center mt-4">
													<Divider
														dashed
														className="mb-2"
													/>
													<XTheme2TextButton
														onClick={() =>
															handleCardExpand(
																company.carrier,
															)
														}
													>
														{expandedCards[
															company.carrier
														]
															? 'Hide Details'
															: 'View Full Score'}
													</XTheme2TextButton>
												</div>

												{expandedCards[
													company.carrier
												] && (
													<div style={{ flex: 1 }}>
														{' '}
														{/* Add this wrapper */}
														<Divider
															dashed
															className="my-2"
														/>
														<div className="hasPadding">
															<div>
																<Row>
																	<Col
																		xs={24}
																	>
																		<XTheme2ViewMoreListCard>
																			%
																			Timely
																			Appeals
																			Processing
																			<Tooltip title="This is the percentage of cases that were processed on time.">
																				<InfoCircleOutlined className="dashboard-tooltip-css" />
																			</Tooltip>
																			<div className="fixedMoreValue">
																				-
																			</div>
																		</XTheme2ViewMoreListCard>
																		<XTheme2ViewMoreListCard>
																			%
																			Paid
																			Timely{' '}
																			<Tooltip title="This is the percentage of cases that were paid on time.">
																				<InfoCircleOutlined className="dashboard-tooltip-css" />
																			</Tooltip>
																			<div className="fixedMoreValue">
																				-
																			</div>
																		</XTheme2ViewMoreListCard>
																		<XTheme2ViewMoreListCard>
																			%
																			Upheld{' '}
																			<Tooltip title="This is the percentage of cases that were rejected and remain rejected after review.">
																				<InfoCircleOutlined className="dashboard-tooltip-css" />
																			</Tooltip>
																			<div className="fixedMoreValue">
																				-
																			</div>
																		</XTheme2ViewMoreListCard>
																		<XTheme2ViewMoreListCard>
																			%
																			Overturned{' '}
																			<Tooltip title="This is the percentage of cases that were initially rejected but then approved at a later stage.">
																				<InfoCircleOutlined className="dashboard-tooltip-css" />
																			</Tooltip>
																			<div className="fixedMoreValue">
																				-
																			</div>
																		</XTheme2ViewMoreListCard>
																		<XTheme2ViewMoreListCard>
																			%
																			Denied{' '}
																			<Tooltip title="This is the percentage of cases that were rejected at any stage in the process, regardless of the final outcome.">
																				<InfoCircleOutlined className="dashboard-tooltip-css" />
																			</Tooltip>
																			<div className="fixedMoreValue">
																				-
																			</div>
																		</XTheme2ViewMoreListCard>
																		<XTheme2ViewMoreListCard>
																			Initial
																			Denial
																			%{' '}
																			<Tooltip title="This is the percentage of cases that were rejected at the initial stage, known as the organization determination stage.">
																				<InfoCircleOutlined className="dashboard-tooltip-css" />
																			</Tooltip>
																			<div className="fixedMoreValue">
																				-
																			</div>
																		</XTheme2ViewMoreListCard>
																	</Col>
																</Row>

																<Row>
																	<Col
																		xs={24}
																	>
																		<XTheme2ViewMorePending className="noPadding">
																			<div className="titleCard">
																				Denial
																				Trends
																				Over
																				the
																				Years
																			</div>
																			<ul>
																				{company.details &&
																					company.details.map(
																						(
																							item,
																							idx,
																						) => (
																							<li
																								className="listColor2"
																								key={
																									idx
																								}
																							>
																								<em>
																									{
																										item.year
																									}
																								</em>
																								{
																									item.count
																								}{' '}
																								Denials
																								<span>
																									$
																									{formatNumber(
																										item.balanceSum ||
																											0,
																									)}
																								</span>
																							</li>
																						),
																					)}
																			</ul>
																		</XTheme2ViewMorePending>
																		<XTheme2ViewMorePending className="noPadding">
																			<ul>
																				<li className="listColor2">
																					<em className="year">
																						{
																							company.totalcount
																						}
																					</em>
																					<bold>
																						Total
																						Count
																					</bold>
																					<span className="doller">
																						$
																						{formatNumber(
																							company.totalBalance ||
																								0,
																						)}
																					</span>
																				</li>
																			</ul>
																		</XTheme2ViewMorePending>
																	</Col>
																</Row>
															</div>
														</div>
													</div>
												)}
											</XTheme2Card>
										</Col>
									))
								) : (
									<Col xs={24}>
										<div className="text-center p-4">
											<strong
												style={{
													color: 'rgba(0, 0, 0, 0.45)',
												}}
											>
												No Records Found
											</strong>
										</div>
									</Col>
								)}
							</Row>
						</>
					</XThemeContainer>
				</>
			)}
		</>
	);
};

const mapStateToProps = (state) => ({
	getCarrierScoreCardState: state.getNanoCarrierDetails, // Changed from state.getCarrierScoreCard
});

const mapDispatchToProps = (dispatch) => ({
	getCarrierScoreCard: (params) => dispatch(getNanoCarrierDetailsApi(params)),
	getCarrierScoreCardReset: () => dispatch(getNanoCarrierDetailsReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReclaimDashboard);
